import React from 'react';
import './TeachModule.css';

const PageNavigation = ({ currentPage, totalPages, onPrev, onNext }) => {
    if (totalPages <= 1) return null;

    return (
        <div className="page-navigation">
            <button
                className="page-arrow prev"
                onClick={onPrev}
                disabled={currentPage === 0}
                aria-label="Previous page"
            >
                <i className="fas fa-chevron-left"></i>
            </button>

            <span className="page-indicator">
                Page {currentPage + 1} of {totalPages}
            </span>

            <button
                className="page-arrow next"
                onClick={onNext}
                disabled={currentPage >= totalPages - 1}
                aria-label="Next page"
            >
                <i className="fas fa-chevron-right"></i>
            </button>
        </div>
    );
};

export default PageNavigation;
